//#region src/kiosk_guest_receipt_mode.ts
var KioskGuestReceiptMode = /* @__PURE__ */ function(KioskGuestReceiptMode) {
	KioskGuestReceiptMode["PrintOnlyCashOrders"] = "print-only-cash-orders";
	KioskGuestReceiptMode["PrintOnlyOnDemandOrders"] = "print-only-on-demand-orders";
	KioskGuestReceiptMode["PrintAllOrders"] = "print-all-orders";
	return KioskGuestReceiptMode;
}(KioskGuestReceiptMode || {});
//#endregion
export { KioskGuestReceiptMode };

//# sourceMappingURL=kiosk_guest_receipt_mode.js.map